import { Injectable, inject } from "@angular/core";
import { AccountObject } from "@tradecafe/types/core";
import { DeepReadonly } from "@tradecafe/types/utils";
import { ModalService } from "src/shared/modal";
import { CompanyFormComponent, CompanyFormOptions } from "./company-form.component";

@Injectable()
export class CompanyFormService {
  private readonly modal = inject(ModalService)


  async showCompanyForm(company: DeepReadonly<AccountObject>, isBulkEdit: boolean, selectedCompanies: DeepReadonly<AccountObject[]>) {
    // fix backend data type
    company = { ...company, archived: company.archived ? 1 : 0 }

    return this.modal.openDialog<
      CompanyFormComponent,
      CompanyFormOptions,
      void
    >(
      CompanyFormComponent,
      { company, isBulkEdit, selectedCompanies },
      {
        panelClass: ['tc-dialog', 'modal-full'],
        width: 'inherit',
        maxWidth: '100%',
        position: {
          top: '30px',
        }
      }
    ).toPromise()
  }
}
